module.exports = __webpack_public_path__ + "img/oceanShippingListImg_4.c6ff05ed.jpg";